<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <div class="vx-row mt-10">
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base">
          <p>Upload your completed certificate:</p>
          <br />
          <fileupload-button-immediate
            v-model="uploaded_files['uploaded_file_1']"
            :is-editable="isEditable"
            filetype="pdf"
          />
          <save-buttons :is-editable="isEditable" @save="save" />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
